import ImageListItem from '@mui/material/ImageListItem';
import { useState } from 'react';
import { api } from '../../../services/api';
import { TimeLineDataType } from '../../../services/apiTypes';
import PostModal from '../../Feed/PostModal';
import SnipzPlayer from '../../Feed/SnipzPlayer';

export default function ProfilePost({
  authorAvatarUrl,
  authorId,
  authorUsername,
  id,
  type,
  medias,
  description,
  tags,
  likes,
  comments,
  createdAt,
  updatedAt,
  isLiked
}: TimeLineDataType) {
  const [modal, setModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<number>(0);
  const [postModal, setPostModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalSelectedImage, setModalSelectedImage] = useState(0);
  const [likesCount, setLikesCount] = useState(likes);
  const [commentsCount, setCommentsCount] = useState(comments);
  const [isLikedState, setIsLikedState] = useState(isLiked);

  const handleModalActions = async (action: string) => {
    if (action === 'post') {
      setPostModal(!postModal);
    } else if (action === 'share') {
      setShareModal(!shareModal);
    } else if (action === 'delete') {
      setPostModal(false);
      setDeleteModal(!deleteModal);
    } else if (action === 'confirmDelete') {
      try {
        api.delete(`/media/publication/${id}`)
      } catch (error) {
        console.log(error)
      }
      setDeleteModal(!deleteModal);
    } else if (action === 'noDelete') {
      setDeleteModal(!deleteModal);
    }
  }

  const handleClose = () => {
    setModal(!modal);
  }

  return (
    <>
      <PostModal
        modal={modal}
        handleClose={handleClose}
        setModal={setModal}
        id={id}
        medias={medias}
        type={type}
        authorUsername={authorUsername}
        authorAvatarUrl={authorAvatarUrl}
        createdAt={createdAt}
        description={description}
        feedType={'snipz'}
        tags={tags}
        likes={likes}
        comments={comments}
        isLiked={isLiked}
        likesCount={likesCount}
        setLikesCount={setLikesCount}
        commentsCount={commentsCount}
        setCommentsCount={setCommentsCount}
        selectedImage={selectedImage}
        modalSelectedImage={modalSelectedImage}
        setModalSelectedImage={setModalSelectedImage}
        isLikedState={isLikedState}
        setIsLikedState={setIsLikedState}
      />
      <ImageListItem
        key={id}
        onClick={() => setModal(true)}
      >
        {type === 'post' ? (
          <>
            <img
              srcSet={`${medias[selectedImage].url}?w=248&fit=crop&auto=format&dpr=2 2x`}
              src={`${medias[selectedImage].url}?w=248&fit=crop&auto=format`}
              loading="eager"
              style={{ borderRadius: 8, width: 256 }}
            />
            {medias.length > 1 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  position: 'absolute',
                  top: 20,
                  right: 20,
                }}
              >
                <Icon />
              </div>
            )}
          </>
        ) : (
          <SnipzPlayer modal={false} isFeed={true} local={false} src={medias[0].url} />
        )}
      </ImageListItem>
    </>
  );
}

function Icon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#FCFCFC"
        d="M21.602 4.5h-.897v15h.897c.33-.002.646-.221.88-.612.233-.39.365-.92.366-1.471V6.583c-.001-.552-.133-1.08-.366-1.471-.234-.39-.55-.61-.88-.612zM1.152 6.583v10.834c.001.552.133 1.08.366 1.471.234.39.55.61.88.612h.897v-15H2.4c-.33.001-.647.221-.88.612-.234.39-.366.92-.367 1.471z"
      ></path>
      <path
        fill="#FCFCFC"
        fillRule="evenodd"
        d="M5.755 4.5h12.222c.368.001.72.177.98.49.261.312.408.735.409 1.176v11.668a1.853 1.853 0 01-.408 1.177c-.26.312-.613.488-.98.489H5.754c-.368-.001-.72-.177-.981-.49a1.853 1.853 0 01-.408-1.176V6.166c.001-.441.148-.864.408-1.177.26-.312.613-.488.98-.489zm.499 12.002H16.98a.319.319 0 00.212-.049.415.415 0 00.154-.183.522.522 0 00-.04-.494l-3.403-4.455a.327.327 0 00-.107-.121.259.259 0 00-.143-.044c-.05 0-.1.015-.143.043a.328.328 0 00-.108.122l-1.277 2.2a.32.32 0 01-.114.112.259.259 0 01-.284-.017.338.338 0 01-.103-.126l-1.57-3.234a.321.321 0 00-.104-.138.246.246 0 00-.147-.05.246.246 0 00-.148.05.321.321 0 00-.103.138l-3.67 5.43a.622.622 0 00-.009.535.511.511 0 00.159.201c.067.05.143.077.22.08zm9.35-6.333a1.505 1.505 0 100-3.01 1.505 1.505 0 000 3.01z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}